export default "__VITE_ASSET__DdLe2LvR__"